module.exports = __webpack_public_path__ + "static/medal-iccws-bronze-0f1aba1e6f3bc34efcc37b1fcbe0117f.png";